import { Timestamp } from "firebase/firestore";
import { Translations } from "shared/types/languages";

export type Studio = {
  id: number;
  name: string;
  logo: string;
  description: string;
  currencies: string[];
  updatedAt: Timestamp;
  productsCount: number;
  translations?: Translations;
};

export type StudioUpdate = Partial<
  Omit<Studio, "logo"> & {
    logo: File;
  }
>;

export enum StudioDetailsTabs {
  General,
  Translations,
}

export type OrderedStudio = {
  id: string;
  name: string;
  gamesCount: number;
  order: number;
};
